import React, { useEffect } from "react";
import Listing from "../Listing";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchlessonBrushedBrushless } from "../../../redux/action/lessonsAction";
import SecureContent from "../../../components/secureContent";

const BrushedVsBrushlessMotors = () => {
  const dispatch = useDispatch();
  const { brushedBrushlessList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );

  useEffect(() => {
    dispatch(fetchlessonBrushedBrushless());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
      <SecureContent/>
      <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Brushed vs. brushless motors"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Brushed vs. brushless motors",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={brushedBrushlessList} color={"#2c3e96"} />

        <Footer />
      </div>
    </>
  );
};

export default BrushedVsBrushlessMotors;
